import Box from '@zenbusiness/zui/Box';
import Grid from '@zenbusiness/zui/Grid';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Root = superstyled({
  name: 'OrderViewDisplayRoot',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    padding: '1.5rem',
    width: '100vw',
    marginTop: '4.625rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '50rem',
      margin: 'auto',
      maxHeight: '80vh',
    },
  }),
});

export const Section = superstyled({
  name: 'OrderViewDisplaySection',
  slot: 'Root',
  tag: Box,
  styles: () => ({
    marginBottom: '4rem',
  }),
});

export const SectionTitle = superstyled({
  name: 'OrderViewDisplaySectionTitle',
  slot: 'Root',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.primary,
    marginBottom: '0.875rem',
  }),
});

export const SectionContent = superstyled({
  name: 'OrderViewDisplaySectionContent',
  slot: 'Root',
  tag: Grid,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: '1rem',
    '& pre': {
      margin: 0,
      overflow: 'hidden',
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
    },
  }),
});

export const ItemTitle = superstyled({
  name: 'OrderViewDisplayItemTitle',
  slot: 'Root',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary,
  }),
});
